import { Inbox, Menu } from 'lucide-react'
import { useNavigate, useParams } from 'react-router-dom'
import { useUIStore } from '../../stores/uiStore'
import { useClientStore } from '../../stores/clientStore'
import agent8Logo from '../../assets/agent8-logo.png'
import { NotificationBell } from './NotificationBell'
import { ClientSwitcher } from './ClientSwitcher'
import { UserMenu } from './UserMenu'

function AIInboxButton() {
  const navigate = useNavigate()

  return (
    <button
      type="button"
      onClick={() => navigate('/review-center')}
      aria-label="AI Inbox"
      title="AI Inbox — Review AI-generated work"
      className="relative inline-flex items-center justify-center size-10 rounded-lg text-black/70 hover:bg-black/[0.05] hover:text-black transition-colors focus-visible:outline-dashed focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-black"
    >
      <Inbox size={17} className="shrink-0" />
    </button>
  )
}

export function Topbar() {
  const { clientId: routeClientId } = useParams<{ clientId: string }>()
  const storeClientId = useClientStore((s) => s.currentClientId)
  const clientId = routeClientId ?? storeClientId ?? undefined
  const setMobileOpen = useUIStore((s) => s.setMobileSidebarOpen)

  return (
    <header className="shrink-0 bg-gradient-to-b from-white via-white via-40% to-transparent">
      <div className="flex flex-col gap-2 px-3 @md/shell:px-6 py-3 @md/shell:py-0 @md/shell:h-20 @4xl/shell:h-28 @md/shell:flex-row @md/shell:items-center @md/shell:gap-4 @md/shell:justify-between">
        {/* Top row — always visible: hamburger + logo (+ Site inline at @md+) | actions */}
        <div className="flex items-center justify-between @md/shell:justify-start gap-2 min-w-0">
          <div className="flex items-center gap-2 min-w-0">
            <button
              type="button"
              onClick={() => setMobileOpen(true)}
              aria-label="Open menu"
              className="@md/shell:hidden inline-flex items-center justify-center size-10 rounded-lg text-black/70 hover:bg-black/[0.05] hover:text-black transition-colors shrink-0"
            >
              <Menu size={20} />
            </button>

            <img
              src={agent8Logo}
              alt="Agent9 by bon8"
              className="h-10 @md/shell:h-14 @4xl/shell:h-24 w-auto shrink-0 object-contain"
            />

            {clientId && (
              <div className="hidden @md/shell:flex items-center gap-2 ml-2 min-w-0">
                <span className="font-450 text-body-sm text-black/55 shrink-0">Client:</span>
                <ClientSwitcher />
              </div>
            )}
          </div>

          {/* On narrow (< @md), AI Inbox + bell + UserMenu sit on row 1 to the right. */}
          <div className="flex items-center gap-1 shrink-0 @md/shell:hidden">
            <AIInboxButton />
            <NotificationBell />
            <UserMenu />
          </div>
        </div>

        {/* Site dropdown — second row on narrow (mobile) only */}
        {clientId && (
          <div className="@md/shell:hidden flex items-center gap-2 min-w-0">
            <span className="font-450 text-body-sm text-black/55 shrink-0">Client:</span>
            <ClientSwitcher />
          </div>
        )}

        {/* Right cluster — visible from @md upward (single-row layout) */}
        <div className="hidden @md/shell:flex items-center gap-2 @md/shell:gap-3 shrink-0">
          <AIInboxButton />
          <NotificationBell />
          <UserMenu />
        </div>
      </div>
    </header>
  )
}
